
export const reportsConfig = {
  title: "Reports Management",
  columns: [
    { field: "accountName", headerName: "Account Name", type: "sort" },
    {
      field: "primaryContact",
      headerName: "Primary Contact",
      type: "multiSelectSort",
    },
    { field: "primaryEmail", headerName: "Primary Email", type: "sort" },
    { field: "accountType", headerName: "Account Type", type: "accountType" },
    { field: "manager", headerName: "Manager", type: "managerFilter" },
    { field: "bookkeeper", headerName: "Bookkeeper" },
    { field: "dashboardDate", headerName: "Dashboard Date", type: "date" }
  ],
  emptyMessage: "No reports found",
};
